<div>
  <!-- Top card -->
  <div class="employee-card" *ngIf="employee">

    <div class="employee-avatar">
      <label>
        <gp-user-avatar [pictureUri]="employee?.photoLink?.href"
                        size="lg">
        </gp-user-avatar>
      </label>
    </div>

    <div class="employee-contract">
      <div class="employee-contract--name">
        <div class="max-w-75">
          <h3>
              <span class="break-word"
                    [class.non-active]="isInactiveContract(selectedContract)">
                {{ employee?.firstName }} <span class="font-weight-bold">{{ employee?.lastName }}</span>
              </span>
          </h3>
        </div>
      </div>

      <!-- Contract switcher -->
      <div class="employee-contract--selector">
        <gp-dropdown-select [ngModel]="essService.selectedContract"
                            [customPlaceholderGenerator]="customPlaceholderGenerator"
                            (ngModelChange)="selectContract($event)"
                            buttonClasses="btn-sm"
                            ngDefaultControl>
          <gp-dropdown-option *ngFor="let contract of employee.contracts"
                              [ngValue]="contract"
                              [class.non-active]="isInactiveContract(contract)">
            <img class="flag-icon" alt="flag-icon"
                 *ngIf="contract.flag"
                 [attr.src]="contract.flag.href"/>
            {{ 'EMPLOYEE_FORM.Contract_name' | translate:{name: contract.cliRegNickName} }}
            {{ getContractDate(contract) }}
          </gp-dropdown-option>
        </gp-dropdown-select>
      </div>

    </div>

    <div class="pull-right">
      <ng-content select=".gp-pull-right"></ng-content>
    </div>

  </div>

  <router-outlet></router-outlet>

</div>
